import React from "react";
import type { Station } from "@/lib/api-client";

interface EmbedHeaderProps {
  station: Station;
  isLive: boolean;
  theme: "light" | "dark";
}

export function EmbedHeader({ station, isLive, theme }: EmbedHeaderProps) {
  const mutedTextColor = theme === "dark" ? "text-[#4fa935]" : "text-gray-600";
  const liveIndicatorColor = theme === "dark" ? "bg-[#6adf47]" : "bg-green-500";

  return (
    <div className="mb-4">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <h1 className="text-lg font-bold truncate leading-tight">
            {station.name}
          </h1>
          <p className={`text-sm truncate leading-tight ${mutedTextColor}`}>
            by @{station.broadcaster.username}
          </p>
        </div>
        {isLive && (
          <div className="flex items-center gap-2 ml-4">
            <div className={`w-2 h-2 rounded-full ${liveIndicatorColor} animate-pulse`} />
            <span className="text-xs uppercase">LIVE</span>
          </div>
        )}
      </div>
    </div>
  );
}
